<template>
  <div class="personalized-tour curated-tour tour" role="presentation">
    <header-mobile>
      <h3>{{ $t('message.personalizedTour') }}</h3>
    </header-mobile>
    <main class="content" aria-label="Main content">
      <div
        v-if="description"
        v-html="$tr(description)"
        class="description"
        role="presentation"
      />
      <div
        v-else
        class="description"
        role="presentation"
      >
        <p>
          {{ $t("personalizedTour.description1") }}
          <span v-if="counter === 0">{{ $t("personalizedTour.description2") }}</span>
          <span v-else>{{ $t("personalizedTour.description3") }}</span>
        </p>
      </div>
      <div class="poi-counter" v-if="counter > 0" role="presentation">
        <span>{{ $t("personalizedTour.poiSelected") }}: {{ counter }}</span>
        <router-link
          :to="{name: 'PersonalizedTour'}"
          tag="a"
          class="btn btn-primary main-background secondary-text"
        >
          {{ $t("personalizedTour.createTour") }}
        </router-link>
      </div>
      <tour-category-list />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import HeaderMobile from '@/components/HeaderMobile'
import TourCategoryList from '@/components/CategoryList'

export default {
  name: 'PersonalizedCategories',
  components: {
    'header-mobile': HeaderMobile,
    'tour-category-list': TourCategoryList
  },
  computed: {
    ...mapState({
      description: state => state.college.settings.personalized_tour.categories_page.description
    }),
    ...mapState('personalized', {
      counter: state => state.poiSelected.length
    })
  }
}
</script>
